/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Integer 0-88, 'N/A', or null
 * @export
 * @interface GgFunctionScorePredictedScore
 */
export interface GgFunctionScorePredictedScore {
}

/**
 * Check if a given object implements the GgFunctionScorePredictedScore interface.
 */
export function instanceOfGgFunctionScorePredictedScore(value: object): value is GgFunctionScorePredictedScore {
    return true;
}

export function GgFunctionScorePredictedScoreFromJSON(json: any): GgFunctionScorePredictedScore {
    return GgFunctionScorePredictedScoreFromJSONTyped(json, false);
}

export function GgFunctionScorePredictedScoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): GgFunctionScorePredictedScore {
    return json;
}

export function GgFunctionScorePredictedScoreToJSON(json: any): GgFunctionScorePredictedScore {
    return GgFunctionScorePredictedScoreToJSONTyped(json, false);
}

export function GgFunctionScorePredictedScoreToJSONTyped(value?: GgFunctionScorePredictedScore | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

